import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import PageShell from "../components/PageShell";
import BottomNav from "../components/BottomNav";
import EmptyState from "../components/EmptyState";
import { ArrowLeft, Bell, Check } from "lucide-react";

const TYPE_ICON = {
  match_full: "🔥",
  player_joined: "👤",
  kicked: "👋",
  cancelled: "❌",
  promoted: "🎉",
  match_reminder: "⏰",
};

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const markAll = async () => {
    await api.post("/notifications/read", {});
    await load();
  };

  return (
    <PageShell>
      <header className="px-4 pt-6 pb-2 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(-1)} data-testid="back-btn" className="h-10 w-10 rounded-full bg-secondary border border-border flex items-center justify-center">
            <ArrowLeft className="h-5 w-5" />
          </button>
          <div>
            <div className="text-xs text-muted-foreground font-bold uppercase tracking-wider">Notifikasi</div>
            <h1 className="font-heading text-2xl font-black tracking-tight">Update Lo</h1>
          </div>
        </div>
        {items.some(n => !n.read) && (
          <button onClick={markAll} data-testid="mark-all-read" className="text-xs font-bold text-primary flex items-center gap-1">
            <Check className="h-3.5 w-3.5" /> Tandai semua
          </button>
        )}
      </header>

      <div className="px-4 mt-4 space-y-2">
        {loading && <div className="h-20 rounded-2xl bg-card animate-pulse" />}
        {!loading && items.length === 0 && (
          <EmptyState icon="🔔" title="Belum ada notifikasi" body="Aktivitas match lo bakal muncul di sini." />
        )}
        {items.map((n) => {
          const inner = (
            <div className={`bg-card border rounded-2xl p-4 flex items-start gap-3 transition-all ${n.read ? "border-border opacity-70" : "border-primary/30"}`}>
              <div className="h-10 w-10 rounded-2xl bg-secondary flex items-center justify-center text-xl">{TYPE_ICON[n.type] || "🔔"}</div>
              <div className="flex-1 min-w-0">
                <div className="font-bold text-sm">{n.title}</div>
                <div className="text-xs text-muted-foreground mt-0.5">{n.body}</div>
                <div className="text-[10px] text-muted-foreground/60 mt-1">{new Date(n.created_at).toLocaleString("id-ID")}</div>
              </div>
              {!n.read && <span className="h-2 w-2 rounded-full bg-primary mt-2" />}
            </div>
          );
          return n.match_id ? (
            <Link to={`/match/${n.match_id}`} key={n.notif_id} data-testid={`notif-${n.notif_id}`}>{inner}</Link>
          ) : (
            <div key={n.notif_id} data-testid={`notif-${n.notif_id}`}>{inner}</div>
          );
        })}
      </div>

      <BottomNav />
    </PageShell>
  );
}
